<div class="flex flex-col sm:flex-row items-start justify-between">
    <div class="text-xl font-medium tracking-tight leading-6 truncate">{{titleText}}</div>
    <!--                <div class="mt-3 sm:mt-0 sm:ml-2">-->
    <!--                    <mat-button-toggle-group-->
    <!--                            value="this-week"-->
    <!--                            #applicationkSelector="matButtonToggleGroup">-->
    <!--                        <mat-button-toggle value="last-week">Scorsa settimana</mat-button-toggle>-->
    <!--                        <mat-button-toggle value="last-week">Scorsa settimana</mat-button-toggle>-->
    <!--                        <mat-button-toggle value="this-month">Questo mese</mat-button-toggle>-->
    <!--                    </mat-button-toggle-group>-->
    <!--                </div>-->
</div>
<div class="flex flex-col md:flex-row gap-6 w-full mt-8 sm:mt-4">
    <!-- New vs. Closed -->
    <div class="flex flex-col flex-auto w-full md:w-2/3">
        <div class="flex flex-col flex-auto">

            <app-dashboard-chart
                    class="h-80"
                    [chartData]="applicationDashboard"></app-dashboard-chart>
        </div>
    </div>
    <!-- Overview -->
    <div class="flex flex-col w-full md:w-1/3">
        <!--                    <div class="font-medium text-secondary">Overview</div>-->
        <div class="flex-auto grid grid-cols-2 gap-4 mt-6">


            <div class="col-span-2 flex flex-col items-center justify-center py-8 px-1 rounded-2xl bg-green-50 text-green-800 dark:bg-white dark:bg-opacity-5 dark:text-green-500">
                <div class="text-5xl sm:text-7xl font-semibold leading-none tracking-tight">
                    {{generalData?.totalApplications}}
                </div>
                <div class="mt-1 text-sm sm:text-lg font-medium">Totali</div>
            </div>

            <!-- Fixed -->
            <div class="col-span-2 sm:col-span-1 flex flex-col items-center justify-center py-8 px-1 rounded-2xl bg-gray-100 text-secondary dark:bg-white dark:bg-opacity-5">
                <div class="text-5xl font-semibold leading-none tracking-tight">
                    {{generalData?.weekApplications}}
                </div>
                <div class="mt-1 text-sm font-medium text-center">Settimana</div>
            </div>
            <!--                        &lt;!&ndash; Won't fix &ndash;&gt;-->
            <div class="col-span-2 sm:col-span-1 flex flex-col items-center justify-center py-8 px-1 rounded-2xl bg-gray-100 text-secondary dark:bg-white dark:bg-opacity-5">
                <div class="text-5xl font-semibold leading-none tracking-tight">
                    {{generalData?.todayApplications}}
                </div>
                <div class="mt-1 text-sm font-medium text-center">Oggi</div>
            </div>
        </div>
    </div>
</div>

